var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageStructure"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"allSection"},[_c('why-choose'),_c('allInOne'),_c('table-compare'),_c('pubBleu')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }